import React from 'react';
import styled from 'styled-components/macro';

import { sections } from '../../../common/config';
import Facebook from '../../../common/components/svg/Facebook';
import Instagram from '../../../common/components/svg/Instagram';
import Twitter from '../../../common/components/svg/Twitter';
import Youtube from '../../../common/components/svg/Youtube';
import { Section, Container, Title, Subtitle, Description } from '../styled';

const PhoneEntry = styled.div`
  margin: 10rem 0;
  display: flex;

  &:first-of-type { margin-top: 40rem }
  .prefix { width: 30rem }
`;

const Icons = styled.div`
  margin-top: 27rem;
  display: flex;

  svg {
    margin-right: 30rem;
    height: 25rem;
  }
`;

const Contact = () => {

  const handleIconClick = (url: string) => {
    window.open(url);
  }

  return (
    <Section $height={sections.height.contact} $align="start">
      <Container $primary>

        <Title>Nice to meet you</Title>
        <Subtitle>Let's get to know each other</Subtitle>
        <Description>
          You can call, write or contact us on social media, we will be
          delighted to talk to you!
        </Description>

        <PhoneEntry>
          <p className="prefix">M.</p>
          <p>contact@somersby.com</p>
        </PhoneEntry>

        <PhoneEntry>
          <p className="prefix">P.</p>
          <p>(+60)3 5533 6688</p>
        </PhoneEntry>

        <Icons>
          <Facebook onClick={() => handleIconClick("https://www.facebook.com/Somersby")} />
          <Instagram onClick={() => handleIconClick("https://www.instagram.com/somersby/")} />
          <Twitter onClick={() => handleIconClick("https://twitter.com/somersby")} />
          <Youtube onClick={() => handleIconClick("https://www.youtube.com/user/SomersbyCiders")} />
        </Icons>

      </Container>

    </Section>
  );
}

export default Contact;